module.exports = __webpack_public_path__ + "static/assets/65f4f96bd6a19bad3ec1d7534372ca48.gif";